import { checkLink } from '@/api/link'
export default {
  /**
   * @description 在进入活动页面路由前，检查当前活动的有效性；如果活动过期，直接跳 404
   */
  async beforeRouteEnter (to, from, next) {
    try {
      await checkLink(to.query.lcActivityWebKey)
      next()
    } catch (err) {
      if (err?.code === 400) {
        next('/404')
        return
      }
      console.error(err)
    }
  }
}
